package dev.danko.roblox_craft_ai.components

import dev.danko.roblox_craft_ai.state.Txt
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderBottom
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.bottom
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxHeight
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import dev.danko.roblox_craft_ai.queue.GenerateQueueScheduler
import dev.danko.roblox_craft_ai.queue.QueuedAsset
import dev.danko.roblox_craft_ai.queue.QueuedStatus
import dev.danko.roblox_craft_ai.queue.formatCompletedAgo
import dev.danko.roblox_craft_ai.queue.formatEta
import dev.danko.roblox_craft_ai.uikit.components.AppButton
import dev.danko.roblox_craft_ai.uikit.components.AppButtonSize
import dev.danko.roblox_craft_ai.uikit.components.AppButtonVariant
import dev.danko.roblox_craft_ai.uikit.components.ToastManager
import dev.danko.roblox_craft_ai.uikit.theme.LocalAppTheme
import dev.danko.roblox_craft_ai.uikit.theme.toAppPalette
import kotlinx.browser.window
import kotlinx.coroutines.delay
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.css.vw

val QueuePanelSheetStyle = CssStyle.base {
    val palette = colorMode.toAppPalette()
    Modifier
        .fillMaxWidth()
        .position(Position.Fixed)
        .left(0.px)
        .bottom(0.px)
        .zIndex(8500)
        .backgroundColor(palette.surfaceElevated)
        .border(1.px, LineStyle.Solid, palette.border)
        .borderRadius(topLeft = 0.75.cssRem, topRight = 0.75.cssRem, bottomLeft = 0.px, bottomRight = 0.px)
        .boxShadow(offsetX = 0.px, offsetY = (-4).px, blurRadius = 24.px, spreadRadius = 0.px, color = palette.surface)
}

val QueueHeaderStyle = CssStyle.base {
    val palette = colorMode.toAppPalette()
    Modifier
        .fillMaxWidth()
        .padding(topBottom = 0.625.cssRem, leftRight = 1.cssRem)
        .gap(0.5.cssRem)
        .borderBottom(1.px, LineStyle.Solid, palette.border)
        .cursor(Cursor.Pointer)
}

@Composable
private fun QueuedAsset.statusColor(): Color {
    val palette = LocalAppTheme.current.colors
    return when (this.status) {
        QueuedStatus.PENDING -> palette.textSecondary
        QueuedStatus.ACTIVE -> palette.statusProcessing
        QueuedStatus.COMPLETED -> palette.statusReady
        QueuedStatus.FAILED -> palette.statusFailed
        QueuedStatus.CANCELLED -> palette.textSecondary
    }
}

private fun QueuedAsset.statusLabel(): String = when (this.status) {
    QueuedStatus.PENDING -> Txt.queue.statusPending
    QueuedStatus.ACTIVE -> Txt.queue.statusRunning
    QueuedStatus.COMPLETED -> Txt.queue.statusDone
    QueuedStatus.FAILED -> Txt.queue.statusFailed
    QueuedStatus.CANCELLED -> Txt.queue.statusCancelled
}

private fun QueuedAsset.typeEmoji(): String = try {
    when (this.type.name) {
        "MESH_3D" -> "🧊"
        "ANIMATION_R15", "ANIMATION" -> "🎬"
        "LUAU_SCRIPT", "LUAU" -> "🧪"
        else -> "📦"
    }
} catch (_: Throwable) { "📦" }

@Composable
fun GenerationQueuePanel() {
    val theme = LocalAppTheme.current
    val palette = theme.colors
    val items = GenerateQueueScheduler.queue
    val size = items.size
    var expanded by remember { mutableStateOf(size > 0) }
    val running = items.count { it.status == QueuedStatus.ACTIVE }
    val pending = items.count { it.status == QueuedStatus.PENDING }

    LaunchedEffect(size) {
        if (size > 0) {
            expanded = true
            delay(4000)
        }
    }
    // An empty queue only takes space at the bottom of the screen; Shift + "Create" brings the panel back.
    if (size == 0 && !GenerateQueueScheduler.isPaused) return

    Box(QueuePanelSheetStyle.toModifier()) {
        Column(Modifier.fillMaxWidth()) {
            Row(
                QueueHeaderStyle.toModifier().onClick { expanded = !expanded },
                verticalAlignment = Alignment.CenterVertically
            ) {
                SpanText(
                    text = if (expanded) "▼" else "▶",
                    modifier = Modifier.fontSize(0.7.cssRem).color(palette.textSecondary).minWidth(1.cssRem)
                )
                SpanText(
                    Txt.queue.title(size),
                    Modifier.fontSize(0.95.cssRem).fontWeight(FontWeight.SemiBold).color(palette.textPrimary)
                )
                if (running > 0) {
                    SpanText(
                        "● $running",
                        Modifier.fontSize(0.78.cssRem).color(palette.statusProcessing).fontWeight(FontWeight.Bold).margin(left = 0.5.cssRem)
                    )
                }
                if (pending > 0) {
                    SpanText(
                        "⏳ $pending",
                        Modifier.fontSize(0.78.cssRem).color(palette.textSecondary).margin(left = 0.5.cssRem)
                    )
                }
                val etaSecs = GenerateQueueScheduler.globalEtaSeconds()
                if (etaSecs != null && etaSecs > 0) {
                    val mm = etaSecs / 60
                    val ss = etaSecs % 60
                    SpanText(
                        Txt.queue.eta(mm.toInt(), ss.toInt()),
                        Modifier.color(palette.textSecondary).margin(left = 0.5.cssRem).fontSize(0.8.cssRem)
                    )
                }
                Spacer()
                var isPausedState by remember { mutableStateOf(GenerateQueueScheduler.isPaused) }
                LaunchedEffect(Unit) {
                    while (true) {
                        delay(500)
                        if (GenerateQueueScheduler.isPaused != isPausedState) {
                            isPausedState = GenerateQueueScheduler.isPaused
                        }
                    }
                }
                AppButton(
                    text = if (isPausedState) Txt.queue.resume else Txt.queue.pause,
                    variant = if (isPausedState) AppButtonVariant.SECONDARY else AppButtonVariant.OUTLINE,
                    size = AppButtonSize.SM,
                    onClick = {
                        if (isPausedState) {
                            GenerateQueueScheduler.resume()
                            isPausedState = false
                            ToastManager.info(Txt.queue.resumed)
                        } else {
                            GenerateQueueScheduler.pause()
                            isPausedState = true
                            ToastManager.warning(Txt.queue.paused)
                        }
                    },
                    modifier = Modifier.margin(right = 0.25.cssRem)
                )
                if (isPausedState) {
                    SpanText(
                        Txt.queue.pausedBadge,
                        Modifier.color(palette.statusPending).margin(right = 0.5.cssRem).fontSize(0.75.cssRem).fontWeight(FontWeight.SemiBold)
                    )
                }
                AppButton(
                    text = Txt.common.clear,
                    variant = AppButtonVariant.OUTLINE,
                    size = AppButtonSize.SM,
                    onClick = {
                        GenerateQueueScheduler.clearCompleted()
                        ToastManager.info(Txt.queue.cleared)
                    }
                )
                AppButton(
                    text = "⬆",
                    variant = AppButtonVariant.OUTLINE,
                    size = AppButtonSize.SM,
                    onClick = {
                        window.asDynamic().scrollTo(0, 0)
                    }
                )
            }

            if (expanded) {
                Column(
                    Modifier
                        .fillMaxWidth()
                        .maxHeight(45.vh)
                        .overflow(Overflow.Auto)
                ) {
                    if (items.isEmpty()) {
                        Row(
                            Modifier
                                .fillMaxWidth()
                                .padding(1.cssRem)
                                .gap(0.5.cssRem),
                            verticalAlignment = Alignment.CenterVertically,
                            horizontalArrangement = Arrangement.Center
                        ) {
                            SpanText(
                                Txt.queue.empty,
                                Modifier.fontSize(0.82.cssRem).color(palette.textSecondary).textAlign(TextAlign.Center)
                            )
                        }
                    } else {
                        val sorted = items.sortedWith(compareBy({ -it.priority }, { it.position }))
                        if (sorted.size > 30) {
                            Row(
                                Modifier
                                    .fillMaxWidth()
                                    .padding(top = 0.5.cssRem, bottom = 0.25.cssRem, left = 1.cssRem, right = 1.cssRem),
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                SpanText(
                                    Txt.queue.scrollTip,
                                    Modifier.fontSize(0.72.cssRem).color(palette.textSecondary)
                                )
                            }
                        }
                        sorted.forEachIndexed { idx, asset ->
                            QueueRowSimple(
                                asset = asset,
                                index = idx,
                                onCancel = {
                                    if (asset.status == QueuedStatus.ACTIVE || asset.status == QueuedStatus.PENDING) {
                                        GenerateQueueScheduler.cancel(asset.uuid)
                                        ToastManager.warning(Txt.queue.taskCancelled)
                                    }
                                },
                                onPriorityUp = { GenerateQueueScheduler.changePriority(asset.uuid, asset.priority + 1) },
                                onPriorityDown = { GenerateQueueScheduler.changePriority(asset.uuid, asset.priority - 1) }
                            )
                        }
                    }
                }
            }
        }
    }
}

@Composable
private fun QueueRowSimple(
    asset: QueuedAsset,
    index: Int,
    onCancel: () -> Unit,
    onPriorityUp: () -> Unit,
    onPriorityDown: () -> Unit
) {
    val theme = LocalAppTheme.current
    val palette = theme.colors
    Row(
        Modifier
            .fillMaxWidth()
            .padding(topBottom = 0.4.cssRem, leftRight = 1.cssRem)
            .gap(0.5.cssRem)
            .borderBottom(1.px, LineStyle.Solid, palette.border)
            .display(DisplayStyle.Flex),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Box(
            Modifier
                .size(0.5.cssRem)
                .borderRadius(999.px)
                .backgroundColor(asset.statusColor())
                .margin(right = 0.25.cssRem)
        )
        SpanText(
            "${asset.typeEmoji()} #${index + 1}",
            Modifier.fontSize(0.8.cssRem).color(palette.textSecondary).minWidth(4.cssRem)
        )
        Column(Modifier.gap(0.125.cssRem).fillMaxWidth(60.percent)) {
            val truncated = if (asset.prompt.length > 48) asset.prompt.take(48) + "…" else asset.prompt
            SpanText(
                truncated,
                Modifier
                    .fontSize(0.88.cssRem)
                    .fontWeight(FontWeight.Medium)
                    .color(palette.textPrimary)
            )
            Row(Modifier.gap(0.5.cssRem)) {
                SpanText(
                    asset.statusLabel(),
                    Modifier.fontSize(0.72.cssRem).color(asset.statusColor()).fontWeight(FontWeight.SemiBold)
                )
                val etaText = if (asset.status == QueuedStatus.ACTIVE) {
                    "≈${formatEta(asset.etaSeconds)}"
                } else if (asset.status == QueuedStatus.COMPLETED) {
                    formatCompletedAgo(asset.completedAtUtc)
                } else if (asset.status == QueuedStatus.PENDING) {
                    Txt.queue.position(asset.position)
                } else {
                    asset.errorMessage?.take(24) ?: ""
                }
                if (etaText.isNotBlank()) {
                    SpanText(
                        "• $etaText",
                        Modifier.fontSize(0.72.cssRem).color(palette.textSecondary)
                    )
                }
            }
        }
        Spacer()
        if (asset.status == QueuedStatus.PENDING) {
            Row(Modifier.gap(0.25.cssRem)) {
                AppButton(
                    text = "↓",
                    variant = AppButtonVariant.OUTLINE,
                    size = AppButtonSize.SM,
                    onClick = onPriorityDown
                )
                SpanText(
                    "P${asset.priority}",
                    Modifier.fontSize(0.7.cssRem).color(palette.textSecondary).margin(leftRight = 0.25.cssRem)
                )
                AppButton(
                    text = "↑",
                    variant = AppButtonVariant.OUTLINE,
                    size = AppButtonSize.SM,
                    onClick = onPriorityUp
                )
            }
        }
        if (asset.status == QueuedStatus.PENDING || asset.status == QueuedStatus.ACTIVE) {
            AppButton(
                text = "✕",
                variant = AppButtonVariant.OUTLINE,
                size = AppButtonSize.SM,
                onClick = onCancel
            )
        }
    }
}
